// extracted by mini-css-extract-plugin
module.exports = {"modal-title":"SummaryEditor_modal-title__3eWR0","summaryEditor":"SummaryEditor_summaryEditor__MHPgb","summaryEditorTitle":"SummaryEditor_summaryEditorTitle__qpMQn"};